import React, { useState, useEffect } from 'react';
import { MdArrowDropDown } from "react-icons/md";
import axios from "axios";
import { toast } from 'react-toastify';
import Constant from '../Utils/Constant';

const EditCouponForm = ({ editPopup, setEditPopup }) => {
    const [isDropdownOpenfilter, setIsDropdownOpenfilter] = useState(false);
    const [cuponevent, setCuponevent] = useState("");
    const [cuponcode, setCuponcode] = useState("");
    const [cupondiscount, setCupondiscount] = useState("");
    const [validdays, setValiddays] = useState("");
    const [cuponassign, setCuponassign] = useState([]);
    const [checkboxStates, setCheckboxStates] = useState([]);
    const [selectAllChecked, setSelectAllChecked] = useState(false);
    const [iscuponcodeValid, setIsCuponcodeValid] = useState(true);
    const [isDiscountValid, setIsDiscountValid] = useState(true);
    const [isValiddaysValid, setIsValiddaysValid] = useState(true);
    const [totalCount1, setTotalCount1] = useState(null);
    const [yourDataArray, setYourDataArray] = useState([
        { id: 1, email: 'Super Admin' },
        { id: 2, email: 'Admin' },
        { id: 3, email: 'Affiliate' },
        { id: 4, email: 'User' },
    ]);

    useEffect(() => {
        setCouponData();
    }, [editPopup]);

    const setCouponData = () => {
        setCuponevent(editPopup.cuponevent);
        setCuponcode(editPopup.cuponcode);
        setCupondiscount(editPopup.cupondiscount);
        setValiddays(editPopup.validdays);
        setCuponassign(editPopup.cuponassign);

        // Initialize checkbox states based on cuponassign
        const initialCheckboxStates = yourDataArray.map(item =>
            editPopup.cuponassign.includes(item.email)
        );
        setCheckboxStates(initialCheckboxStates);
        setSelectAllChecked(initialCheckboxStates.every(Boolean));
    };

    const toggleDropdownfilter = () => {
        setIsDropdownOpenfilter(!isDropdownOpenfilter);
    };

    // Function to handle checkbox change for a specific item
    const handleCheckboxChanged = (id) => {
        const index = id - 1; // Adjust index to start from 0
        const newCheckboxStates = [...checkboxStates];
        newCheckboxStates[index] = !newCheckboxStates[index];
        setCheckboxStates(newCheckboxStates);

        const selectedAccess = yourDataArray
            .filter((_, i) => newCheckboxStates[i])
            .map(item => item.email);
        setCuponassign(selectedAccess);
    };

    // Function to handle "Select All" checkbox change
    const handleSelectAllChanged = () => {
        const newSelectAllChecked = !selectAllChecked;
        setSelectAllChecked(newSelectAllChecked);
        const newCheckboxStates = Array(yourDataArray.length).fill(newSelectAllChecked);
        setCheckboxStates(newCheckboxStates);

        const selectedAccess = newSelectAllChecked
            ? yourDataArray.map((item) => item.email)
            : [];
        setCuponassign(selectedAccess);
    };

    const countCheckedUsers = () => {
        return checkboxStates.filter((isChecked) => isChecked).length;
    };

    // Validations
    const validateCuponcode = (cupondiscount) => {
        const cuponcodeRegex = /^[a-zA-Z0-9]+$/;
        return cuponcodeRegex.test(cuponcode);
    };
    const validateCupondiscount = (cupondiscount) => {
        const cupondiscountRegex = /^[0-9]+$/;
        return cupondiscountRegex.test(cupondiscount);
    };
    const validateValiddays = (validdays) => {
        const validdaysRegex = /^[0-9]+$/;
        return validdaysRegex.test(validdays);
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        const iscuponcodeValid = validateCuponcode(cupondiscount);
        const isDiscountValid = validateCupondiscount(cupondiscount);
        const isValiddaysValid = validateValiddays(validdays);
        setIsCuponcodeValid(iscuponcodeValid);
        setIsDiscountValid(isDiscountValid);
        setIsValiddaysValid(isValiddaysValid);

        if (iscuponcodeValid && isDiscountValid && isValiddaysValid) {
            try {
                const cuponData = {
                    cuponevent,
                    cuponcode,
                    cupondiscount,
                    validdays,
                    cuponassign,
                };
                const response = await axios.put(
                    `${Constant.BASE_URL}/cupon/update/${editPopup._id}`,
                    cuponData
                );

                if (response.status === 200) {
                    // Clear form fields
                    setCuponevent("");
                    setCuponcode("");
                    setCupondiscount("");
                    setValiddays("");
                    setCuponassign([]);

                    // Success message
                    toast.success("Coupon updated successfully");

                    // Close the edit popup after 2 seconds
                    setTimeout(() => {
                        setEditPopup(false);
                    }, 2000);
                } else {
                    console.log("Update failed:", response.status);
                }
            } catch (error) {
                console.log(error);
            }
        }
    };
    return (

        <div className="popup-form">
            <div className="flex items-center justify-center w-full">
                <div className="p-4 px-1 py-3 bg-white rounded-md shadow-md lg:py-3 xl:py-3 2xl:p-4 ">
                    <div className="items-center justify-center w-fit">
                        <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl ">
                            Edit Coupon
                        </div>
                        <hr className="mt-1 " />
                        <form onSubmit={handleUpdate}>
                            <div className="flex flex-col items-center justify-center ">
                                <div className="lg:py-5 xl:py-5 2xl:py-10 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                                    <div className="flex items-center justify-end py-3">
                                        <label
                                            htmlFor="yourInput"
                                            className="flex items-end px-3"
                                        >
                                            Coupon Event :
                                            <span className="ml-1 text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="yourInput"
                                            className="flex items-start mb-2 border-b border-gray-500 outline-none"
                                            style={{ width: "163px", textAlign: "center" }}
                                            placeholder="Text"
                                            value={cuponevent}
                                            onChange={(e) => setCuponevent(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="flex items-center justify-end py-3">
                                        <label
                                            htmlFor="yourInput"
                                            className="flex items-end px-3"
                                        >
                                            Coupon Code :
                                            <span className="ml-1 text-red-500">*</span>
                                        </label>
                                        <div className="flex flex-col">
                                            <input
                                                type="text"
                                                id="couponCode"
                                                name="couponCode"
                                                className="flex items-start mb-2 border-b border-gray-500 outline-none"
                                                style={{ width: "163px", textAlign: "center" }}
                                                placeholder="Alpha Numeric"
                                                value={cuponcode}
                                                onChange={(e) => setCuponcode(e.target.value)}
                                                required
                                            />
                                            {!iscuponcodeValid && (
                                                <p className="text-red-500">
                                                    Invalid cuponcode. Should be alpha-numeric.
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-end py-3">
                                        <label
                                            htmlFor="yourInput"
                                            className="flex items-end px-3"
                                        >
                                            Coupon Discount :
                                            <span className="ml-1 text-red-500">*</span>
                                        </label>
                                        <div className="flex flex-col">
                                            <input
                                                type="text"
                                                id="couponDiscount"
                                                name="couponDiscount"
                                                className="flex items-start mb-2 border-b border-gray-500 outline-none"
                                                style={{ width: "163px", textAlign: "center" }}
                                                placeholder="Number %"
                                                value={cupondiscount}
                                                onChange={(e) => setCupondiscount(e.target.value)}
                                                required
                                            />
                                            {!isDiscountValid && (
                                                <p className="text-red-500">
                                                    Invalid cupondiscount. Should be a number.
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-end py-3">
                                        <label
                                            htmlFor="yourInput"
                                            className="flex items-end px-3"
                                        >
                                            Valid Days :<span className="ml-1 text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="yourInput"
                                            className="flex items-start mb-2 border-b border-gray-500 outline-none"
                                            style={{ width: "163px", textAlign: "center" }}
                                            placeholder="Text (10 Days)"
                                            value={validdays}
                                            onChange={(e) => setValiddays(e.target.value)}
                                            required
                                        />
                                        {!isValiddaysValid && (
                                            <p className="text-red-500">
                                                Invalid validdays. Should be a number.
                                            </p>
                                        )}
                                    </div>
                                    <div className="flex justify-end">
                                        <div className="relative flex items-center justify-start py-3 cursor-pointer mb-8">
                                            <label htmlFor="yourInput" className="flex items-end px-3">
                                                Coupon assign : {countCheckedUsers()} selected / {yourDataArray.length}
                                                <span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <div className="flex pb-1 border-b border-gray-500 outline-none ">
                                                <input
                                                    type="text"
                                                    placeholder="Select category"
                                                    value={cuponassign.join(', ')}
                                                    readOnly
                                                    style={{ border: "none", outline: "none" }}
                                                    required
                                                />
                                                <MdArrowDropDown
                                                    onClick={toggleDropdownfilter}
                                                    className="text-xl"
                                                />
                                                {isDropdownOpenfilter && (
                                                    <div
                                                        style={{
                                                            border: "1px solid #0000000a",
                                                            zIndex: "100",
                                                        }}
                                                        className="lg:text-[10px] xl:w-[163px] lg:w-fit xl:text-[15px] py-1 absolute top-9 left-25 bg-white shadow-xl rounded-md "
                                                    >
                                                        <ul className='overflow-y-auto h-[130px] modelscroll'>
                                                            <li className="border-t px-2 py-1 cursor-pointer text-black flex justify-between items-center">
                                                                <span className='text-[12px]'>All</span>
                                                                <div className='flex justify-end items-center'>
                                                                    <label className="inline-flex items-center">
                                                                        <div className={`w-4 h-4 bg-white border border-black-300 shadow-lg rounded-sm flex items-center justify-center ml-2 ${selectAllChecked ? 'bg-red-500' : ''}`}>
                                                                            {selectAllChecked && (
                                                                                <div className="w-2 h-2 bg-gradient-to-r from-yellow-200 to-orange-500"></div>
                                                                            )}
                                                                        </div>
                                                                        <input
                                                                            className="hidden"
                                                                            type="checkbox"
                                                                            checked={selectAllChecked}
                                                                            onChange={handleSelectAllChanged}
                                                                        />
                                                                    </label>
                                                                </div>
                                                            </li>
                                                            {yourDataArray.map((item) => (
                                                                <li key={item.id} className="border-t px-2 py-1 cursor-pointer text-black flex justify-between items-center">
                                                                    <span className="text-[12px]">{item.email}</span>
                                                                    <div className="flex items-center">
                                                                        <label className="inline-flex items-center">
                                                                            <div className={`w-4 h-4 bg-white border border-black-300 shadow-lg rounded-sm flex items-center justify-center ml-2 ${checkboxStates[item.id - 1] ? 'bg-red-500' : ''}`}>
                                                                                {checkboxStates[item.id - 1] && (
                                                                                    <div className="w-2 h-2 bg-gradient-to-r from-yellow-200 to-orange-500"></div>
                                                                                )}
                                                                            </div>
                                                                            <input
                                                                                className="hidden"
                                                                                type="checkbox"
                                                                                checked={checkboxStates[item.id - 1]}
                                                                                onChange={() => handleCheckboxChanged(item.id)}
                                                                            />
                                                                        </label>
                                                                    </div>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className="button-container flex justify-center p-1 space-x-12 lg:pb-1 xl:pb-5 2xl:pb-5 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]"
                                >
                                    <button
                                        onClick={() => { setEditPopup(false) }}
                                        type="button"
                                        className="flex-shrink-0 px-3 py-1 bg-white shadow-md rounded-sm"
                                        style={{
                                            boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                                        }}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        type="submit"
                                        className="flex-shrink-0 px-3 py-1 rounded-sm"
                                        style={{
                                            background:
                                                "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                                        }}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default EditCouponForm